import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const fallbackLng = 'fa'
const defaultNS = 'translation'

i18n.use(initReactI18next).init({
  fallbackLng,
  debug: true,
  defaultNS,
  fallbackNS: [
    'auth',
    'local',
    'configs',
    'register',
    'profileInfo',
    'payment',
  ],
  resources: {
    en: {
      auth: {},
    },
    fa: {
      auth: {},
      local: {
        next: 'بعدی',
        roles: 'قوانین',
        next_level: 'مرحله بعدی',
        back: 'عقب',
        back_level: 'مرحله قبلی',
        password: 'رمز عبور',
        birthday: 'تاریخ تولد',
        national_code: 'کد ملی',
        username: 'نام کاربری',
        policy: 'قوانین و مقررات',
        discountCode: 'کد تخفیف',
        confirm: 'تأیید',
        cancel: 'لغو',
        clean: 'پاک کردن',
        repeat: 'تکرار',
        mobile_number: 'شماره همراه',
        mobile_number_register: 'شماره همراه ثبت نام کننده',
        save: 'ثبت',
        testPay: 'پرداخت هزینه آزمون',
        availPay: 'هزینه قابل پرداخت: 1.220.000 ریال',
        required: 'ضروری است',
        parents: 'والدین',
        father: 'پدر',
        mother: 'مادر',
        student: 'آزمون دهنده',
        registrant: 'ثبت نام کننده',
        login: 'ورود',
        login_successful: 'ورود موفقیت امیز',
        information: 'اطلاعات',
        name: 'نام',
        firstName: 'نام',
        registerer: 'ثبت نام کننده',
        lastName: 'نام خانوادگی',
        and: 'و',
        sex: 'جنسیت',
        man: 'مرد',
        woman: 'زن',
        exam: 'آزمون',
        code: 'کد',
        number: 'عدد',
        amount: 'مبلغ',
        final: 'نهایی',
        received: 'دریافتی',
        five: 'پنج',
        digit: 'رقمی',
        reset: 'بازنشانی',
        send: 'ارسال',
        six: 'شش',
        second: 'ثانیه',
        rials: 'ریال',
        birthDate: 'تاریخ تولد',
        success: 'موفق',
        failed: 'ناموفق',
        user: 'کاربر',
      },
      configs: {

      },
      register: {
        accept_role: 'قوانین را قبول دارم',
        bylaw: 'آیین نامه',
        register_on_panel_talent: 'ثبت نام در پنل استعدادیابی',
        registrant: 'ثبت نام کننده',
        register_button: 'ثبت نام',
        register_policy: 'با ایجاد حساب در این سایت من با قوانین و مقررات موافقت دارم.',
        policy_require: 'قوانین و مقررات ضروری است',
        receiving_information: 'دریافت اطلاعات',
        must_be_exactly_ten_characters: 'حتما باید ۱۰ رقمی باشد',
        must_be_exactly_eleven_characters: 'حتما باید 11 رقمی باشد',
        passwordـmustـbeـatـleast_eight_characters: 'رمز عبور حداقل 8 کاراکتر باشد',
        password_and_its_repetition_must_be_the_same: 'رمزعبور و تکرار آن باید یکی باشند',
        final_approval: 'تایید نهایی',
        examiner: 'آزمون دهنده',
        discount: 'تخفیف',
        code_was_sent_to_you: 'کد برای شما ارسال شد',
        register_successfuly: 'ثبت نام با موفقیت انجام شد',
        answer_successfuly: 'ثبت پاسخ با موفقیت انجام شد',
        addAddress_successfuly: 'ثبت ادرس با موفقیت انجام شد',
        exam_successfuly: 'آزمون با موفقیت انجام شد',
        addBasket_successfuly: 'دوره با موفقیت به سبد خرید اضافه شد',
        deleteBasket_successfuly: 'حذف با موفقیت انجام شد',
        codeـmustـbeـsix_characters: 'کد باید 6 رقمی باشد',
        enterـcode_sent: 'کد ارسال شده را وارد کنید',
        i_forget_password: 'فراموشی رمز عبور',
        please_enter_username: 'لطفا نام کاربری خود را وارد کنید',
        enter_recived_code_and_new_password: 'کد ارسال شده به همراه رمز عبور جدید را وارد کنید',
        change_password_successfuly: 'تغییر رمز با موفقیت انجام شد',
        new_Password: 'رمز عبور جدید',
        send_again: 'ارسال مجدد',
        recived_code: 'کد دریافت شده',
        pay_for_the_test: 'پرداخت هزینه آزمون',
        description_exam: 'فرآیند استعدادیابی',
        bank_mellat_payment_gateway: 'درگاه پرداخت بانک ملت',
        bank_saman_payment_gateway: 'درگاه پرداخت بانک سامان',
        payment: 'پرداخت',
        selected_test_for_you: 'آزمون منتخب برای شما',
        fee_payable: 'هزینه قابل پرداخت بعلاوه %9 مالیات بر ارزش افزوده',
        your_mobile: 'شماره شما',
        code_has_not_been_sent_to_you: 'کد برای شما ارسال نشده است',
        your_payment_was_successful: 'پرداخت شما با موفقیت انجام شد',
        sorry_your_payment_failed: 'متاسفانه پرداخت شما با مشکل مواجه شد',
        payment_number: 'شناسه پرداخت',
        track_number: 'شماره پیگیری',
        login_to_the_user_panel: 'ورود به پنل کاربری',
        polocy_description: '',
      },
      profileInfo: {
        great: 'خواندن و نوشتن',
        degree: 'سیکل',
        deploma: 'دیپلم',
        associateDegree: 'فوق دیپلم/کاردانی',
        bachelor: 'لیسانس/کارشناسی',
        master: 'فوق لیسانس/کارشناسی ارشد',
        phd: 'دکترا',
        tv: 'تلویزیون',
        freinds: 'دوستان',
        classmate: 'همکلاسی',
        sms: 'پیامک',
        radio: 'رادیو',
        none: 'هیچکدام',
        male: 'مرد',
        female: 'زن',
        intersex: 'میان جنسی',
        iran: 'ایران',
        afghanistan: 'افغانستان',
        parents: 'والدین',
        father: 'پدر',
        mother: 'مادر',
        student: 'آزمون دهنده',
      },
      payment: {
        payment_status: 'وضعیت پرداخت',
        internet_payment_gateway: 'درگاه پرداخت',
        error_message: 'پیام خطا',
        Package_name: 'نام پکیج',
        new: 'جدید',
        paying: 'پرداخت شده',
        confirming: 'تایید شده',
        success: 'موفق',
        failed: 'ناموفق',
        mellat: 'ملت',
        saman: 'سامان',
        pay_pending: 'پرداخت نشده',
        PayPending: 'پرداخت نشده',
        event_pending: 'در حال بررسی',
        event_Accepted: 'تایید شده',
        event_Rejected: 'رد شده',
        paid: 'پرداخت شده',
        paid_exam: 'شرکت در آزمون',
        Sent: 'ارسال شده',
        Delivered: 'تحویل داده شده',
        inprogress: 'در حال پیشرفت',
        completed: 'گذرانده شده',
        expired: 'منقضی شده',
        PaidAndLocked: 'منقضی شده',
        StartedAndlocked: 'منقضی شده',
        ResultCalculating: 'در حال بررسی',
        resultReady: 'مشاهده نتایج',
        pay: 'پرداخت',
        participating_in_test: 'ورود به آزمون',
        finishedQuiz: 'شما قبلا به این آزمون پاسخ داده اید',
      },
    },
  },
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  react: {
    wait: false,
  },
})

export default i18n
